import { PrismicRichText } from "@prismicio/react";
import React from "react";
import * as s from "./index.module.scss";

const TitleSection = ({ title, description, maxWidth }) => {
  return (
    <div
      className={`d-flex flex-column justify-content-center align-items-center w-100 mx-auto ${s.title_section_wrapper}`}
      style={{ maxWidth: maxWidth }}
    >
      <PrismicRichText field={title} />
      <PrismicRichText field={description} />
    </div>
  );
};

export default TitleSection;
